module.exports = __webpack_public_path__ + "img/gb2238-80a.asm.beaa7b10.jpg";